import { useState, useEffect, useContext } from 'react';
import {baseURL} from '../Config/settings'

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm'
import './CSS/Payment.css'
import Loading from '../Loading';

import { userContext } from '../App';
import { toast } from 'react-toastify';

const stripePromise = loadStripe('pk_test_51KJEN6SB6ePdcq7ghRrFN9XbagFQpCcIXkexQfD4VUbivOxRWkT1PnnTwvxACAMWCjk8nMlZLFioV55YayGthvG500cgUTyyEv');


const Payment = () => {
    const [secret, setSecret] = useState(null)
    const {user, setUser} = useContext(userContext)

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
      const getClientSecret = () => {

        fetch(`${baseURL}/payment/test-payment/`,{
            method: "POST",
            signal: signal,
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
            setSecret(data.client_secret)})
        .catch(err => {
            toast.error(err, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
        })
        }
        getClientSecret()

        return () => {
            controller.abort()
        }
    }, [])

    const options = {
        clientSecret: secret,
        appearance: {
        theme: 'night'
        }
    }

    const PaymentCode = () => {
        return (
            <div className='payment-main'>
            <div style={{color: "black"}}>
      <p>Sandbox Credentials</p>
      <p>Number: 4242424242424242</p>
      <p>Brand: Visa</p>
      <p>CVC: Any 3 digits</p>
      <p>Date: Any Future Date</p>
    </div>
        {secret === null ? <Loading></Loading>: <Elements stripe={stripePromise} options={options}>
          <CheckoutForm secret={secret}></CheckoutForm>
        </Elements>}
        </div>
    )
    }

    const paidUserCode = () => {
        return (
            <div style={{textAlign: 'center', height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div>
                    <h3 style={{color: 'black'}}>I know you loved AlgorithmsExpert &#128521;,</h3>
                    <h3 style={{color: 'black'}}>but you really dont need to pay up twice</h3>
                </div>
            </div>
        )
    }

    return ( 
        <div>
            {user && user.tier === 'P'? paidUserCode(): PaymentCode()}
        </div>
    )
}

export default Payment
